import {
  QDialog,
  QCard,
  QCardSection,
  QCardActions,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QBtnGroup,
  QIcon,
  QSeparator,
  QLinearProgress,
  QTooltip,
  QInput,
  QItem,
  QItemSection,
} from 'quasar';

export default {
  QDialog,
  QCard,
  QCardSection,
  QCardActions,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QBtnGroup,
  QIcon,
  QSeparator,
  QLinearProgress,
  QTooltip,
  QInput,
  QItem,
  QItemSection,
};
